<template>
    <div class="form-group">
        <div class="row">
            <div class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">受理單</label>
                    <select class="form-control"
                        :disabled="mode === 'view'"
                        v-model="modelValue.acknowledgment_id"
                        @change="getIntakeData()"
                    >
                        <option :value="-1">請選擇受理單</option>
                        <option v-for="(acknowledgment,index) in acknowledgmentList" :key="index"
                            :value="acknowledgment.id"
                        >{{ acknowledgment.acknowledgment_serial_no }}</option>
                    </select>
                </div>
            </div>
            <div
                class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">病歷編號</label>
                    <input class="form-control" type="text"
                        v-model="modelValue.serial_no"
                        disabled
                    />
                </div>
            </div>
            <div
                class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">入院日期</label>
                    <input class="form-control" type="date"
                        v-model="modelValue.admission_date"
                    />
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">晶片/腳環/發報器</label>
                    <input class="form-control" type="text"
                        v-model="modelValue.tracking_device_sn"
                        :disabled="mode==='view'"
                    />
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">獸醫師</label>
                    <select class="form-control"
                        :disabled="mode === 'view'"
                        v-model="modelValue.main_doctor"
                    >
                        <option :value="-1">請選擇獸醫師</option>
                        <option v-for="(account,index) in doctorList" :key="index"
                            :value="account.id"
                        >{{ account.name }}</option>
                    </select>
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">物種類別</label>
                    <select class="form-control"
                        disabled
                        v-model="modelValue.species_category_id"
                    >
                        <option v-for="(species,index) in speciesTypes" :key="index"
                            :value="species.id"
                        >{{ species.code }}-{{ species.name }}</option>
                    </select>
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">物種</label>
                    <select class="form-control"
                        :disabled="mode==='view'"
                        v-model="modelValue.species_id"
                    >
                        <option v-for="(specie,index) in animals" :key="index"
                            :value="specie.id"
                        >
                            {{ specie.name }}
                        </option>
                        
                    </select>
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">別名</label>
                    <input class="form-control me-2" type="text"
                        :disabled="mode==='view'"
                        v-model="modelValue.alias_name"
                    />
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">外觀特徵</label>
                    <input class="form-control me-2" type="text"
                        :disabled="mode==='view'"
                        v-model="modelValue.characteristics"
                    />
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">性別</label>
                    <select class="form-control"
                        :disabled="mode==='view'"
                        v-model="modelValue.gender_id"
                    >
                        <option :value="0">請選擇性別</option>
                        <option :value="1">公</option>
                        <option :value="2">母</option>
                        <option :value="3">待查</option>
                    </select>
                </div>
            </div>
            <div v-if="modelValue.gender_id == 2"
                class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">懷孕狀況</label>
                    <select class="form-control"
                        :disabled="mode==='view'"
                        v-model="modelValue.pregnancy_status"
                    >
                        <option :value="1">未懷孕</option>
                        <option :value="2">懷孕中</option>
                        <option :value="3">哺乳中</option>
                    </select>
                </div>
            </div>
            <div v-if="mode !=='create'"
                class="col-12"
            >
                <div class="mb-3 mb-xl-3" v-if="modelValue.status_id">
                    <label class="form-label">目前狀態</label>
                    <select class="form-control"
                        :disabled="mode==='view' || formStatus == 94"
                        v-model="modelValue.status_id"
                    >
                        <option v-for="(statusItem,index) in getStatusList"
                            :key="index"
                            :disabled="!statusItem.isSelect"
                            :value="statusItem.id">{{ statusItem.name }}</option>
                    </select>
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">院內位置</label>
                    <select class="form-control"
                        :disabled="mode==='view'"
                        v-model="modelValue.location_id"
                    >   
                        <option :value="-1">請選擇院內位置</option>
                        <option v-for="(location,index) in locationList" :key="index"
                            :value="location.id"
                            :disabled="!location.isSelect"
                        >{{ location.name }}</option>
                    </select>
                </div>
            </div>

            
            <div v-if="mode !=='create'"
                class="col-12 col-xl-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">救援原因</label>
                    <selectedDropMenu
                        class="mb-2"
                        :disabled="mode==='view'"
                        v-model="modelValue.rescure_reason_id"
                        :options="getRescureReasonList"
                        :dir="'top'"
                    ></selectedDropMenu>
                    <input v-if="modelValue.rescure_reason_id != -1"
                        class="form-control" type="text"
                        :disabled="mode==='view'"
                        v-model="modelValue.rescure_reason_note"
                    />
                    
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import selectedDropMenu from '@/components/selectedDropMenu.vue'
export default {
    name:'healthRecord-forms',
    props:{
        mode:{
            type:String,
            default:'view'
        },
        acknowledgmentList:{
            type:Array,
            default:()=>[]
        },
        modelValue:{
            type:Object,
            default:{
                acknowledgment_id:null,
                serial_no:'',
                main_doctor:-1,
                species_category_id:-1,
                species_id:-1,
                tracking_device_sn:'',
                alias_name:'',
                characteristics:'',
                gender_id:0,
                pregnancy_status:1,
                location_id:-1,
                latest_weight:0.0,
                status_id:null,
                create_time:'',
                admission_date: '',
                rescure_reason_id:-1,
                rescure_reason_note:''
            }
        },
        formStatus:{
            type:Number,
            default:0
        }
    },
    data(){
        return {
            speciesTypes:[],
            animals:[],
            doctorList:[],
            locationList:[],
            reacueReason: [],
            statusList:[]
        }
    },
    components: {
        selectedDropMenu
    },
    watch: {
        'modelValue.species_category_id'(to, from) {
            // 当路由变化时调用方法重新加载数据
            this.getAnimals()
        },
    },
    computed:{
        getRescureReasonList(){
            let itemList = [{value:-1,name:'請選擇救援原因'}]
            for (let index = 0; index < this.reacueReason.length; index++) {
                const item = this.reacueReason[index];
                itemList.push({
                    value: item.id,
                    name: `${item.name}`
                })
            }
            return itemList
        },
        getStatusList(){
            let statusList = []
            if ( this.formStatus == 93 ){
                statusList = this.$parameters.statusList.filter(status => [93].includes(status.id));
            }else if ( this.formStatus == 100 || this.formStatus == 404 ){
                statusList = this.$parameters.statusList.filter(status => [100,404].includes(status.id));
            }else{ //
                statusList = this.$parameters.statusList.filter(status => [3,4,5,6,7,91,92,94,95,96,100,404].includes(status.id));
            }
            return statusList
        }
    },
    methods:{
        async initView(statusList){
            //取得物種分類清單
            const speciesCategoryRes = await this.$api.species.getSpeciesCategoryByName({
                columeName:'code',
                orderby:'ASC'
            });
            if ( speciesCategoryRes.code !== 200 ){
                return
            }
            this.speciesTypes = speciesCategoryRes.data

            this.statusList = statusList

            //取得院內參數 == 4
            const ParameterRes = await this.$api.parameters.getParameterOptions()
            if ( ParameterRes.code !== 200 ){
                return
            }
            this.locationList = this.$api.parameters.getSelectOption(4,ParameterRes.data,this.modelValue.location_id)
            this.reacueReason = this.$api.parameters.getSelectOption(1,ParameterRes.data,this.modelValue.rescure_reason_id)
            //取得獸醫師清單
            this.$api.users.getAccountMainDoctor().then((res)=>{
                if ( res.code !== 200 ){
                    return
                }
                this.doctorList = res.data
                //這裡之後要處理建立的時候要有預設值
            })


        },
        async getAnimals(){      
            this.$debug('getAnimals:',this.modelValue.species_category_id)  
            if ( this.modelValue.species_category_id == -1 ){
                this.animals = []
                return
            }    
            const res = await this.$api.species.getSpeciesByNameAndSpeciesCategoryId({
                species_category_id:this.modelValue.species_category_id
            })
            if ( res.code !== 200 ){
                this.animals = []
                return
            }
            this.animals = res.data
        },
        async getIntakeData(){
            if ( this.modelValue.acknowledgment_id == -1 ){
                return
            }
            this.$store.state.loadingStatus = true
            const res = await this.$api.intake.getAcknowledgmentFormById({
                id:this.modelValue.acknowledgment_id
            })
            this.$store.state.loadingStatus = false
            if ( res.code !== 200 ){
                return
            }

            this.$emit('getIntakeData',res.data)
        }
    },
    async mounted(){
        await this.initView()
    },
    async created(){
        
        
    }
  };
</script>
<style scoped>
.healthRecord-detail.columns .form-group .col-12 {
    flex: 0 0 auto;
    width: 20% !important;
}
</style>